import axiosClient from "./axios";
import {TaskProps} from "../store/tasksSlice";
import {sendCodeProps} from "../store/codesSlice";


export const getUser = async (telegramData: {data:string, invitation_code:string}) => {
    const tempData = {
        ...telegramData,
        data: telegramData.data || 'user=%7B%22id%22%3A50313912%2C%22first_name%22%3A%22Aleksandrs%22%2C%22last_name%22%3A%22Kauhovs%22%2C%22language_code%22%3A%22ru%22%2C%22allows_write_to_pm%22%3Atrue%7D&chat_instance=-8384227031818451573&chat_type=private&start_param=sdrhy3242d&auth_date=1724843756&hash=7c8546101afc795f261f465d97eecc479128f24d0eb9a63843a4665bafd2cf2c',
        invitation_code: telegramData.invitation_code || 'dddd'
    };
    // @TODO remove on production
    // await new Promise((resolve, reject) => {setTimeout(resolve, 300);});
    return await axiosClient.post(`players/register/`, tempData);
}

export const getToken = async (refresh_token: string | null) => {
    return await axiosClient.post(`players/refresh/`, {refresh: refresh_token});
}

export const getStrike = async () => {
    return await axiosClient.get(`strikes/register/`);
}

export const getSwipeState = async () => {
    return await axiosClient.get(`codes/hint/`);
}

export const setSwipe = async () => {
    return await axiosClient.get(`codes/swipe/`)
}

export const getTasks = async () => {
    return await axiosClient.get(`tasks/progress/`);
}

export const setTask = async (taskData: TaskProps) => {
    return await axiosClient.post(`tasks/start/`, {task_id: taskData.task_id})
}

export const claimTask = async (taskData: TaskProps) => {
    return await axiosClient.post(`tasks/claim/`, {task_id: taskData.task_id})
}

export const getReferrals = async () => {
    return await axiosClient.get(`players/referrals/`);
}

export const getCodes = async () => {
    return await axiosClient.get(`codes/progress/`);
}

export const getCodeAttempts = async () => {
    return await axiosClient.get(`codes/attempt/`);
}

export const setCode = async (codeData: sendCodeProps) => {
    return await axiosClient.post(`codes/guess/`, codeData);
}

export const claimReferrals = async () => {
    return await axiosClient.get(`players/claim/`);
}

export const finishTutorial = async () => {
    return await axiosClient.post(`players/tutorial/`);
}
